import { DeprecatedNumber, type NumberOtherProps } from "@octopusdeploy/design-system-octopus-components";
import { withBoundField } from "./BoundField";
export const BoundNumber = withBoundField<number | undefined, NumberOtherProps>(DeprecatedNumber);
